export default window.CONFIG;
